export default window.CONFIG;
